import { DefaultChannelSlug } from "@/app/config";

/** Saleor channel slug — from env, never part of the public URL path. */
export function getDefaultChannelSlug(): string {
	return DefaultChannelSlug ?? "standard";
}
